/**
 * (c) LBS logics
 *
 *     Mobile Business Technology GmbH
 *     4020 Linz, Austria
 *
 *     www.lbs-logics.com
 *
 *     created on 20190402 by Jan Brunner
 *     all rights reserved.
 */
import { Injectable } from '@angular/core';
import { RemoteAction } from 'src/app/_model/remote-action/remote-action';
import { Resetable } from '../../resetter/resetable';

/**
 * DataAccessObject for Remote Actions
 */
@Injectable()
export abstract class RemoteActionDaoService implements Resetable {
  /**
   * Adds a RemoteActions to the already saved ones
   * @param remoteAction the new Remote Action that should be appended
   */
  public abstract addRemoteAction(remoteAction: RemoteAction): Promise<void>;

  /**
   * Loads all RemoteActions from the storage
   * @returns an array of RemoteActions
   */
  public abstract getRemoteActions(): Promise<RemoteAction[]>;


  /**
   * Loads the next cached RemoteAction
   * @param nonFifo if true only fifo irrelevant remote actions are considered
   */
  public abstract getNextRemoteAction(nonFifo: boolean): Promise<RemoteAction>;

  /**
   * Removes a given remote action from the storage
   * @param remoteAction the remote action that should be removed
   */
  public abstract removeRemoteAction(remoteAction: RemoteAction): Promise<void>;

  // Clearable
  public abstract reset(): Promise<void>;
  public abstract clear(): Promise<void>;
}
